import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, Dialog } from '@gumtree/ui-library';
import { track } from '@gumtree/shared/src/actions';
import ReportSellerBlock from './report-seller-block'; // Assuming it's in the same directory
import type { VipState } from '../../reducers'; // Adjust path as needed
import { ReportWrapper, ReportDesc } from "./report.style";

// Selector to get necessary state for the ReportButton
const selectReportButtonState = (state: VipState) => ({
    advertId: state.adDetails.id,
    token: state.adDetails.token,
    sendReportSuccess: state.sellerActions.sendReportSuccess,
});

const ReportButton: React.FC = () => {
    const { advertId, token, sendReportSuccess } = useSelector(selectReportButtonState);
    const [isReportOpen, setIsReportOpen] = useState(false);

    const toggleReportOpen = useCallback(() => {
        if (!sendReportSuccess && !isReportOpen) {
            track('ReportAdBegin');
        }
        setIsReportOpen(!isReportOpen);
    }, [isReportOpen, sendReportSuccess]);

    const closeReport = useCallback(() => setIsReportOpen(false), []);

    if (!advertId || !token) {
        // Don't render if essential data is not available
        return null;
    }

    return (
        <ReportWrapper>
            <ReportDesc>Is there something about this ad that doesn't seem right?</ReportDesc>
            <Button
                display="secondary"
                label="Report ad"
                className="reporter"
                onClick={toggleReportOpen}
            />
            {isReportOpen && (
                <Dialog isOpen={isReportOpen} onClose={closeReport} title="Report Seller">
                    <ReportSellerBlock
                        csrfToken={token}
                        id={advertId}
                        isOpen
                        stateClick={closeReport}
                    />
                </Dialog>
            )}
        </ReportWrapper>
    );
};

ReportButton.displayName = 'ReportButton';

export default ReportButton;
